import request from '../axios'
import website from "../config/website";



export const getGzrz = (id) => request({
  url: '/yzfcapi/yzfc-biz/gzrz/detail?id=' + id,
  method: 'get'
});

export const getGjrz = (id) => request({
  url: '/yzfcapi/yzfc-biz/alertlog/detail?id=' + id,
  method: 'get'
});

export const getCaptcha = () => request({
  url: '/yzfcapi/blade-auth/oauth/captcha',
  method: 'get'
});

export const loginByUsername = (tenantId, username, password, type, key, code) => request({
  url: '/yzfcapi/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    'Captcha-Key': key,
    'Captcha-Code': code,
  },
  params: {
    tenantId,
    username,
    password,
    grant_type: (website.captchaMode ? "captcha" : "password"),
    scope: "all",
    type
  }
});

export const loginBySocial = (tenantId, source, code, state) => request({
  url: '/yzfcapi/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId
  },
  params: {
    tenantId,
    source,
    code,
    state,
    grant_type: "social",
    scope: "all",
  }
})

//手机号找回=》发送验证码
export const sendMsm = (data) => request({
  url: '/yzfcapi/blade-xcx/sdMss',
  method: 'post',
  data: data
});

//手机号登陆
export const loginByPhone = (tenantId, username, password, key) => request({
  url: '/yzfcapi/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    'Captcha-Key': key,
  },
  params: {
    tenantId,
    username,
    password,
    grant_type: 'phone',
    scope: "all",
  }
});

export const refreshToken = (refresh_token, tenantId) => request({
  url: '/yzfcapi/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId
  },
  params: {
    tenantId,
    refresh_token,
    grant_type: "refresh_token",
    scope: "all",
  }
});

export const getUserInfo = () => request({
  url: '/yzfcapi/blade-user/info',
  method: 'get'
});

export const logout = () => request({
  url: '/yzfcapi/blade-auth/oauth/logout',
  method: 'get'
});

export const changStatus = (rescode, resvalue) => request({
  url: '/yzfcapi/yzfc-biz/datav/device/operateDeviceSwitch',
  method: 'post',
  params: {
    rescode,
    resvalue
  }
});

export const changStatus1 = (deviceId, status) => request({
  url: '/yzfcapi/yzfc-biz/datav/device/updateDeviceStatus',
  method: 'post',
  params: {
    deviceId,
    status
  }
});

export const getXscData = (workCode, type) => request({
  url: '/yzfcapi/yzfc-biz/datav/work/reservoir-list',
  method: 'get',
  params: {
    workCode,
    type
  }
});

export const getBqjsData = () => request({
  url: '/yzfcapi/yzfc-biz/devices/list?parentId=1575678565688659971',
  method: 'get',
});

export const getCjqjData = (workCode) => request({
  url: '/yzfcapi/yzfc-biz/datav/work/pond-list',
  method: 'get',
  params: {
    workCode,
  }
});

export const getYxjcData = (workCode) => request({
  url: '/yzfcapi/yzfc-biz/datav/monitor/pond-list',
  method: 'get',
  params: {
    workCode,
  }
});

export const getDeviceData = (workCode, type) => request({
  url: '/yzfcapi/yzfc-biz/datav/device/reservoirDeviceList',
  method: 'get',
  params: {
    workCode,
    type
  }
});

export const getSbData = (group, workCode) => request({
  url: '/yzfcapi/yzfc-biz/datav/device/waterPump',
  method: 'get',
  params: {
    group,
    workCode
  }
});

export const getgjData = (action) => request({
  url: '/yzfcapi/yzfc-biz/datav/gzgj-stats',
  method: 'get',
  params: {
    action
  }
});